import { cn } from '@/lib/cn';

export interface AccountTipsCardProps {
  title: string;
  body: string;
  className?: string;
}

export function AccountTipsCard({ title, body, className }: AccountTipsCardProps) {
  return (
    <div
      className={cn(
        'flex w-full flex-col gap-2 overflow-hidden rounded-md bg-bg-elevated p-4',
        className,
      )}
    >
      <p className="text-label-m font-bold text-text-primary">{title}</p>
      <p className="text-[12px] leading-normal text-text-secondary">{body}</p>
    </div>
  );
}
